export const TelemedWidgetName = {
	// Doctis widget variants for Telemed starting page
	eventsList: 'Events',
	urgent: 'UrgentConsultation',
	specializations: 'CreatingAppointmentWithSpecialist',
	secondOpinion: 'SecondOpinion',
	telecheckup: 'Telecheck',
	medicalCard: 'ConclusionsOnConsultations',
	// Doctis widget variants for Symptom checker and pushes
	doctorsListFromSymptomChecker: 'CreateConsultationDoctorsList',
	patientConsultation: 'PatientConsultation',
	doctorProfileFromSymptomChecker: 'CreateConsultationDoctorProfile',
	digitalSymptomChecker: 'OpenSymptomChecker',
};

export const SymptomCheckerCallback = {
	Emergency: 'onCallAnAmbulance',
	CallingDoctor: 'onSendApplication',
	Telemed: 'onOpenDoctorsList',
	Chat: 'onOpenOnlineChat',
	CallCC: 'onCallContactCenter',
	GoBack: 'onOpenProfile',
};

export const SOURCE_PARAM = 'symptomChecker';

export const SOURCE_PARAM_KEY = 'rgstm_source';
